import axios , {
    AxiosError
} from "axios";
import config from "../lib/config";
import useUserStore from "../store/userStore";



const baseConfig = {
    baseURL: config.api.url,
    withCredentials: false
}

const instance = axios.create(baseConfig);

instance.interceptors.request.use(
    function (config) {
        const accessToken = useUserStore.getState().accessToken;

        if (accessToken) {
           config.headers.Authorization = `Bearer ${accessToken}` ;
        }

        return config;
    },
    function (error) {
        return Promise.reject(error)
    }
)
instance.interceptors.response.use(
    function (response) {
        return response;
    },
    async function (error) {
        const originalRequest = error.config;

        if (
            error.response?.status === 401 &&
            originalRequest &&
            !originalRequest._retry
        ) {
            originalRequest._retry = true;
            try {
                const response = await getRefreshToken();

                const { payload } = response;

                useUserStore.setState({ accessToken: payload.accessToken });

                originalRequest.headers.Authorization = `Bearer ${payload.accessToken}`;

                return instance(originalRequest);
            } catch (error) {
                if (error.response?.status === 403) {
                    useUserStore.getState().removeCredentials();
                    return;
                }
            }
        }

        return Promise.reject(error);
    }
)
export default instance;
